import type { DisablerEvent, ESN } from '@cobliteam/common-types';
import type { Configuration } from '../..';
import HttpMethod from '../../request/HttpMethod';
import HttpStatusCode from '../../request/HttpStatusCode';
import Requester from '../../request/Requester';
import type { IRequest } from '../../request/Types';
import { eventsAPIToDisablerEvent } from './APITransformers';

export class DisablerRequester {
  private requester: Requester;

  constructor(configuration: Configuration) {
    this.requester = new Requester(configuration);
  }

  public getFleetDevicesStatus = (): Promise<DisablerEvent[]> => {
    const requestData: IRequest = {
      endpoint: 'disabler/devices',
      method: HttpMethod.GET,
    };

    return this.requester
      .request(requestData, [HttpStatusCode.NOT_FOUND])
      .then((response) => (response.data ? eventsAPIToDisablerEvent(response.data) : []))
      .catch((err) => {
        if (err.response && err.response.status === HttpStatusCode.NOT_FOUND) {
          return [];
        }
        throw err;
      });
  };

  public requestDisable = (deviceId: ESN): Promise<void> => {
    const requestData: IRequest = {
      endpoint: `disabler/devices/${deviceId}`,
      method: HttpMethod.PUT,
    };

    return this.requester.request(requestData).then();
  };

  public requestEnable = (deviceId: ESN): Promise<void> => {
    const requestData: IRequest = {
      endpoint: `disabler/devices/${deviceId}`,
      method: HttpMethod.DELETE,
    };

    return this.requester.request(requestData).then();
  };
}

export default DisablerRequester;
